package dev.lingvo.site.components.studio.compose

/** Minimal PNG framing; no metadata or alpha chunks are emitted. */
internal object PngChunks {
    private const val MAX_IDAT = 65536
    private val signature = byteArrayOf(-119, 80, 78, 71, 13, 10, 26, 10)

    fun assemble(width: Int, height: Int, compressed: ByteArray): ByteArray {
        require(compressed.isNotEmpty()) { "Zlib stream is empty" }
        val count = (compressed.size.toLong() + MAX_IDAT - 1) / MAX_IDAT
        val size = 8L + 25L + compressed.size + count * 12L + 12L
        require(size <= Int.MAX_VALUE) { "PNG is too large" }
        val output = ByteArray(size.toInt())
        signature.copyInto(output)
        val header = ByteArray(13)
        writeInt(header, 0, width)
        writeInt(header, 4, height)
        header[8] = 8
        header[9] = 2
        var position = chunk(output, 8, "IHDR", header, 0, header.size)
        var source = 0
        while (source < compressed.size) {
            val length = minOf(MAX_IDAT, compressed.size - source)
            position = chunk(output, position, "IDAT", compressed, source, length)
            source += length
        }
        chunk(output, position, "IEND", byteArrayOf(), 0, 0)
        return output
    }

    fun writeInt(output: ByteArray, offset: Int, value: Int) {
        for (index in 0..3) output[offset + index] = (value ushr (24 - index * 8)).toByte()
    }

    private fun chunk(output: ByteArray, offset: Int, type: String, data: ByteArray, start: Int, length: Int): Int {
        writeInt(output, offset, length)
        for (index in 0..3) output[offset + 4 + index] = type[index].code.toByte()
        data.copyInto(output, offset + 8, start, start + length)
        writeInt(output, offset + 8 + length, Crc32.of(output, offset + 4, length + 4))
        return offset + 12 + length
    }
}
